<script lang="ts">
    import type { InputDefinition } from 'header/types';

    interface Props {
        field: InputDefinition<unknown>;
    }

    let { field }: Props = $props();

    let stringField = $derived(JSON.stringify(field, null, 2));
</script>

<details class="field">
    <summary>Unexpected field type.</summary>
    <pre>{stringField}</pre>
</details>

<style lang="scss" scoped>
    .field {
        padding-top: 0.2rem;
        font-size: 0.8rem;
        overflow-x: auto;

        pre {
            margin: 0;
        }
    }
</style>
